import React, { FC } from 'react';
import * as DataTableTypes from '../utils/DataTableTypes';
import { StyledTd } from '../utils/DataTableStyledElements';

export interface TdProps
  extends Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'css' | 'ref'> {
  'data-sticky-td'?: boolean;
  dataTest: string | undefined;
  columnName: string | undefined;
  border: DataTableTypes.DataTableBorder | undefined;
  resizeTableColumns: boolean;
}

export const Td: FC<React.PropsWithChildren<TdProps>> = ({
  resizeTableColumns,
  dataTest,
  columnName,
  border,
  ...props
}) => (
  <StyledTd
    {...props}
    $border={border}
    $resizeTableColumns={resizeTableColumns}
    data-test={dataTest ?? 'data-table-td'}
    role="cell"
    data-test-cell={columnName}
  />
);
